import React, { useEffect, useState } from "react";
import {
    createBrowserRouter, RouterProvider, Outlet,
    useNavigate
} from "react-router-dom";
import { Button, Result, Flex, Layout, Menu, theme, Divider, Typography, Avatar, Drawer } from "antd";
import {
    LogoutOutlined, UploadOutlined, UserOutlined, ContainerOutlined, FileTextOutlined, DollarOutlined,
    FileProtectOutlined, UserSwitchOutlined, AuditOutlined,
    TrophyOutlined,
    KeyOutlined,
    MenuOutlined,
    CloseOutlined
} from '@ant-design/icons';

import LOGORET from './images/logo-nova-retangular-branco.png'
import LOGO from './images/logomarca_CRQ.png'
import { titleize } from './service/util'
import { userState } from './service/database'
import { useRecoilState } from 'recoil'
import { useToasts } from 'react-toast-notifications';

import { AreaRegistradoLogin } from './view/AreaRegistradoLogin';
import { AreaRegistradoForgot } from './view/AreaRegistradoForgot';
import { AreaRegistrado } from "./view/registrado/AreaRegistrado";
import { RegistradoDeclaracao } from "./view/registrado/declaracao";
import { RegistradoFinanceiro } from "./view/registrado/financeiro";
import { ART } from "./view/registrado/art/art";
import { CRT } from "./view/registrado/crt/crt";
import { RegistradoOportunidade } from "./view/registrado/oportunidades";
import { CertificadoPJ } from "./view/registrado/certificadopj";
import NoRegisterHome from './view/naoregistrado'
import ConsultaProfissional from "./view/naoregistrado/consultaProfissional";
import ConsultaFirma from "./view/naoregistrado/consultaFirma";
import ConsultaART from "./view/naoregistrado/consultaART";
import ConsultaCRT from "./view/naoregistrado/consultaCRT";
import ValidarDeclaracaoQuitacao from "./view/naoregistrado/validarDeclaracaoQuitacao";
import { CRTAprovadas } from "./view/registrado/crt/crtAprovadas";
import { CRTNova } from "./view/registrado/crt/crtNova";
import { ARTNova } from "./view/registrado/art/nova";
import { AlterarSenha } from "./view/registrado/alterarSenha";
import { isMobile } from "react-device-detect";
import ValidaPJ from "./view/registrado/validaPJ";
import OutletRegistrado from './view/registrado/outletRegistrado'
import {CRTAprovadasPJ} from "./view/registrado/crt/CrtAprovadasPJ";
import EncontreProfissional from "./view/registrado/encontreProfissional";
import { CRTBaixadas } from "./view/registrado/crt/crtbaixadas";

const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
    backgroundColor: '#215a8a'
};


const Erro404 = (props) => {
    const navigate = useNavigate()
    return <Result
        status="404"
        title="404"
        subTitle="Desculpa, a pagina que você visitou não existe!"
        extra={<Button type="primary" onClick={() => {
            navigate("/")
        }}>Voltar principal</Button>}
    />
}



const Rotas = (props) => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <NoRegisterHome />,
        },
        {
            path: "/consulta/profissional",
            element: <ConsultaProfissional />,
        },
        {
            path: "/consulta/firma",
            element: <ConsultaFirma />,
        },
        {
            path: "/consulta/art",
            element: <ConsultaART />,
        },

        {
            path: "/valida/certidao-crt",
            element: <ConsultaCRT />,
        },
        {
            path: "/valida/certidao-crt",
            element: <ConsultaCRT />,
        },
        {
            path: "/valida/certidao-crt/:code",
            element: <ConsultaCRT />,
        },
        {
            path: "/valida/declaracao-quitacao",
            element: <ValidarDeclaracaoQuitacao />,
        },
        {
            path: "/login",
            element: <AreaRegistradoLogin />,
        },
        {
            path: "/forgot",
            element: <AreaRegistradoForgot />,
        },
        {
            path: "/valida/certificado/pj",
            element: <ValidaPJ />,
        },
        {
            path: "/valida/certificado/pj/:code",
            element: <ValidaPJ />,
        },
        {
            path: "/registrado",
            element: <OutletRegistrado />,
            children: [
                {
                    path: "/registrado",
                    element: <AreaRegistrado />,
                },
                {
                    path: "/registrado/declaracao",
                    element: <RegistradoDeclaracao />,
                },
                {
                    path: "/registrado/financeiro",
                    element: <RegistradoFinanceiro />,
                },
                {
                    path: "/registrado/art",
                    element: <ART />,
                    
                },
                /* {
                     path: "/registrado/art/nova",
                     element: <ARTNova />,
                 },
                 */
                {
                    path: "/registrado/oportunidades",
                    element: <RegistradoOportunidade />,
                },
                {
                    path: "/registrado/certificado",
                    element: <CertificadoPJ />,
                },
                {
                    path: "/registrado/crt/solicitacoes",
                    element: <CRT />,
                },
                {
                    path: "/registrado/crt",
                    element: <CRTAprovadas />,
                },
                {
                    path: "/registrado/crt/baixadas",
                    element: <CRTBaixadas />,
                },
                {
                    path: "/registrado/crt-pj",
                    element: <CRTAprovadasPJ />,
                },
                {
                    path: "/registrado/alterar-senha",
                    element: <AlterarSenha />,
                },
                 {
                    path: "/registrado/banco-de-talentos",
                    element: <EncontreProfissional />,
                },
                /* {
                     path: "/registrado/crt/nova",
                     element: <CRTNova />,
                 },
                 */
            ]
        },

        {
            path: "*",
            element: <Erro404 />
        }
    ])

    return <RouterProvider router={router} />

}

export default Rotas